import { ActionType } from 'src/types/common/common';
import { ResponsiveTabAdaptor } from 'src/constrains/DraggableModules/Components';
import { dispatch } from '@/src/store';
import { onLoadData } from 'src/constrains/ResponsiveLayerEditor/slice';
import { generateTabContent } from 'src/constrains/DraggableModules/tools';

const ResponsiveContentTabFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  onCollapseOpen,
}) => {
  const handleOnContentItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };
  const handleOnContentItemReselect = (id, images) => {
    // const _n = optionsToNum[ContentType] || 1;
    // const _o = data || [generateResponsiveImage()];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.reselect, id, data: images });
    }
  };

  const handleOnContentItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnContentStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnContentItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnCloseAllCollapses = () => {
    if (onCollapseOpen) onCollapseOpen([]);
  };

  const handleOnContentModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };

  const handleOnContentItemAdd = (id, data) => {
    // const _n = optionsToNum[ContentType] || 1;
    //
    const _o = data || [generateTabContent()];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: _o });
    }
  };

  const handleOnOpenImageTab = (data) => {
    handleOnCloseAllCollapses();
    setTimeout(() => {
      dispatch(onLoadData(data));
    });
  };

  return {
    handleOnContentItemChange,
    handleOnContentItemSort,
    handleOnContentStaticChange,
    handleOnContentModuleTypeChange,
    handleOnOpenImageTab,
    handleOnContentItemReselect,
    handleOnContentItemAdd,
    handleOnContentItemDelete,
  };
};
const generateResponsiveContentTab = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  onCollapseOpen,
}) => {
  const {
    handleOnContentItemChange,
    handleOnContentItemSort,
    handleOnContentStaticChange,
    handleOnContentModuleTypeChange,
    handleOnOpenImageTab,
    handleOnContentItemReselect,
    handleOnContentItemAdd,
    handleOnContentItemDelete,
  } = ResponsiveContentTabFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
    onCollapseOpen,
  });
  return {
    component: ResponsiveTabAdaptor,
    props: {
      onItemDelete: handleOnContentItemDelete,
      onItemChange: handleOnContentItemChange,
      onItemSort: handleOnContentItemSort,
      onStaticChange: handleOnContentStaticChange,
      onModuleTypeChange: handleOnContentModuleTypeChange,
      onOpenNewTab: handleOnOpenImageTab,
      onItemReselect: handleOnContentItemReselect,
      onItemAdd: handleOnContentItemAdd,
    },
  };
};
export { generateResponsiveContentTab };
